import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { Carousel, CarouselProps, SlideHandle } from 'nuka-carousel'
import { rem } from 'polished'

const CarouselWrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding: 0 ${rem(15)};
`

const Highlight = styled.div`
  position: absolute;
  left: ${rem(15)};
  bottom: 0;
  width: ${rem(280)};
  height: ${rem(4)};
  background-color: ${props => props.theme.palette.brand.primary.normal};
`

interface Props {
  offers: Array<App.Offer | App.OfferSummary>
  onSlideChange: (id: string) => void
  carouselSettings: Partial<CarouselProps>
  hasHighlight?: boolean
}

class OfferCarousel extends PureComponent<React.PropsWithChildren<Props>> {
  currentSlide: number
  carousel: SlideHandle | null

  constructor(props: Props) {
    super(props)
    this.currentSlide = 0
  }

  goToSlideForOffer(offerId: string) {
    const index = this.props.offers.findIndex(
      offer => offer.id === offerId,
    )
    if (this.carousel && index > -1 && index !== this.currentSlide) {
      this.carousel.goToPage(index)
      this.currentSlide = index
    }
  }

  afterSlide = (newIndex: number) => {
    const { onSlideChange, offers } = this.props
    this.currentSlide = newIndex

    const selectedOffer = offers[newIndex]
    if (selectedOffer) {
      onSlideChange && onSlideChange(selectedOffer.id)
    }
  }

  render() {
    const { children, hasHighlight, carouselSettings } = this.props

    return <CarouselWrapper>
      <Carousel
        {...carouselSettings}
        ref={(el: SlideHandle | null) => { this.carousel = el }}
        afterSlide={this.afterSlide}
        wrapMode="wrap"
        swiping
      >
        { children }
      </Carousel>
      {hasHighlight && <Highlight />}
    </CarouselWrapper>
  }
}

export default OfferCarousel
